import ProgressBar, { ProgressBarProps } from 'react-bootstrap/ProgressBar';

type ProgressBarPropsType = ProgressBarProps & {
  current: number;
  totalNum: number;
  header?: React.ReactNode | string;
};

export const PratusProgressBar = ({
  current,
  totalNum,
  header,
  ...props
}: ProgressBarPropsType) => {
  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        <span>{header}</span>
        {current}/{totalNum}
      </div>
      <ProgressBar
        {...props}
        now={(current / totalNum) * 100}
        className={props.className}
        style={{
          backgroundColor: 'var(--neutral-400)',
          height: '8px',
        }}
      />
    </>
  );
};
